import nodeCash from '../../../../../models/node-cash.js';

/**
 * Price a node-cash transfer: draw the requested tokens greedily from the buckets in order,
 * costing each withdrawal at that bucket's unit price (fee / originalBalance), then double
 * the total. Returns an error instead when the buckets can't cover the request.
 */
export function calculateTransferPrice(tokens: number, buckets: nodeCash[]): { transferPrice: number; error?: string } {
  const available = buckets.reduce((total: number, bucket: nodeCash) => total + bucket.currentBalance, 0);
  if (tokens > available) {
    return { transferPrice: 0, error: 'We do not have sufficient balance' };
  }

  let totalCost = 0;
  let remainingTokens = tokens;
  buckets.forEach((bucket: nodeCash) => {
    if (remainingTokens === 0) return;

    const unitPrice = bucket.fee / bucket.originalBalance;
    let withdrawnTokens = 0;
    if (bucket.currentBalance >= remainingTokens) withdrawnTokens = remainingTokens;
    if (bucket.currentBalance < remainingTokens) withdrawnTokens = bucket.currentBalance;
    remainingTokens = remainingTokens - withdrawnTokens;
    totalCost = totalCost + withdrawnTokens * unitPrice;
  });

  return { transferPrice: totalCost * 2 };
}
